import React, { useMemo } from 'react';

import { useAppSelector } from '../../../../hooks/react-redux';
import { HomePageChart } from '../../../auth/login/store/types';
import { Document } from '../../../shared/icons';
import { getDocumentSpreadAnalytics, getFetchingAnalytics } from '../../store';
import { ChartLoading } from '../ChartLoading';
import styles from '../Modules.module.scss';
import { PieChartWrapper } from '../PieChartWrapper';

const { lightestGrey } = styles;

interface DocumentSpreadChartProps {
    dimensions?: {
        height: number;
        width: number;
    }
    analyticsSpinner: boolean;
}

export const DocumentSpreadChart: React.FC<DocumentSpreadChartProps> = ({ dimensions, analyticsSpinner }) => {
    const documentSpreadAnalytics = useAppSelector(getDocumentSpreadAnalytics);
    const fetchingAnalytics = useAppSelector(getFetchingAnalytics);
    const showSpinner = useMemo(() => fetchingAnalytics.includes(HomePageChart.DOCUMENT_SPREAD) || analyticsSpinner, [fetchingAnalytics, analyticsSpinner]);

    if (showSpinner) {
        return <ChartLoading dimensions={dimensions} />;
    }

    return (
        <PieChartWrapper
            data={documentSpreadAnalytics}
            dimensions={dimensions}
            icon={Document}
            testId='homepage-document-spread'
            label='Document Types'
            iconFill={lightestGrey}
        />
    );
};
